/**
 * Centralized helpers for building portal and order URLs.
 * Use these instead of referencing environment variables directly.
 */

/**
 * Returns the base origin for member/order site.
 */
export function getOrderBaseOrigin(): string {
  return process.env.REACT_APP_ORDER_URL || 'https://order.joggo.jp'
}

/**
 * Returns the base origin for the portal site.
 */
export function getPortalBaseOrigin(): string {
  return process.env.REACT_APP_PORTAL_URL || 'https://joggo.jp'
}

/**
 * Builds a URL under the order site origin.
 */
export function buildOrderUrl(path: string): URL {
  return new URL(path, getOrderBaseOrigin())
}

/**
 * Builds a URL under the portal site origin.
 */
export function buildPortalUrl(path: string): URL {
  return new URL(path, getPortalBaseOrigin())
}
